module.exports = __webpack_public_path__ + "img/alarm.8b4d9606.svg";